import { PageBounding } from "../api/backend-api"

export function getSkipParamForPage(command: string|number, skip: number, limit: number): number {
    if (command === '-1') {
        return skip - limit;
    }
    if (command === '+1') {
        return skip + limit;
    }
    
    let to_page = Number.parseInt(`${command}`)
    to_page -= 1;
    return (limit * to_page);
}

export function getPageBounding(total: number, limit: number, skip: number): PageBounding[] {

    if (!total || total < limit) {
        return [{number: 0, current: false} as PageBounding];
    }

    // const firstPage = Math.max(1)

    const pages = []
    const maxPages = Math.ceil(total / limit)
    const currPage = (skip / limit)+1

    // const lastPage  = Math.min(maxPages)

    // console.log(`max: ${maxPages}, cur: ${currPage}, first: ${firstPage}, last: ${lastPage}`)

    pages.push(
        {
            number: 1,
            current: (currPage === 1)
        } as PageBounding
    );

    if (maxPages == 1) {
        return pages
    }
    
    if (currPage > 2) {
        pages.push(
            {
                number: 0,
                current: false
            } as PageBounding
        );    

        if (currPage == maxPages && maxPages > 3) {
            pages.push(
                {
                    number: currPage - 2,
                    current: false
                } as PageBounding
            );    
        }

        pages.push(
            {
                number: currPage - 1,
                current: false
            } as PageBounding
        );
    }

    if (currPage != 1 && currPage != maxPages) {
        pages.push(
            {
                number: currPage,
                current: true
            } as PageBounding
        );
    }

    if (currPage < maxPages - 1) {
        pages.push(
            {
                number: currPage + 1,
                current: false
            } as PageBounding
        );

        if (currPage == 1 && maxPages > 3) {
            pages.push(
                {
                    number: currPage + 2,
                    current: false
                } as PageBounding
            );
        }    

        if (maxPages > 3) {
            pages.push(
                {
                    number: 0,
                    current: false
                } as PageBounding
            );    
        }
    }

    pages.push(
        {
            number: (maxPages > 0 ? maxPages : 0),
            current: (currPage === maxPages)
        } as PageBounding
    );

    return pages
}